import CalendarComponent from '../Components/CalendarComponent';
import { auth } from '../Utils/firebaseConfig'
import { useState } from 'react';

import './Calendar.css';

function App() {
  const [isLoggedin, setIsLoggedIn] = useState(false)
  const [user, setUser] = useState([])

  auth.onAuthStateChanged((user) => {
    if (user) {
      setIsLoggedIn(!!user);
      setUser(user)
    } else {
      window.location.href = '/'
    }
  });
  return (
    <div>
      {isLoggedin ? (
        <CalendarComponent user={user} />
      ) : <></>}
    </div>
  );
}

export default App;
